import { Grid } from '@mui/material';
import { IUtilityRequest, gridTags } from 'app/models/Placement/PlacementMods';
import React, { useEffect, useState } from 'react';
import { getFormattedUtility } from '../../ModificationsUtils';
import { useTranslation } from 'react-i18next';
import { getUtilityGridColumns } from './helper';
import { usePromiseTracker } from 'react-promise-tracker';
import { XGrid } from '@AMIEWEB/Common/XGrid/XGrid';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrentModDetails,
  selectEditUtilitiesRows,
  selectFurnitureCostToTravelerError,
  selectIsEditMod,
  selectIsUndoModal,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { furnitureModStyles } from './FurnitureMod.styles';
export const UtilityGrid = ({
  utilityRequests,
  isExpanded,
}: {
  utilityRequests: IUtilityRequest[];
  isExpanded: boolean;
}) => {
  const { t } = useTranslation();
  const isModEdit = useSelector(selectIsEditMod);
  const dispatch = useDispatch();
  const { promiseInProgress: isCallingAPI } = usePromiseTracker({ area: 'furniture-details-api', delay: 0 });
  const selectedModsDetails = useSelector(selectCurrentModDetails);
  const utilityEditRequests = useSelector(selectEditUtilitiesRows);
  const [selectedIds, setSelectedIds] = useState<any[]>([]);
  const { classes } = furnitureModStyles({ isExpanded });
  const [columns, setColumns] = useState<any>(
    getUtilityGridColumns(t, isExpanded, isModEdit, utilityEditRequests, classes),
  );
  const furnitureCostToTravelerErrors = useSelector(selectFurnitureCostToTravelerError);
  const [headerCount, setHeaderCount] = useState<number>(0);
  const [secondaryCount, setSecondaryCount] = useState<number>(0);
  const isUndoModal = useSelector(selectIsUndoModal);
  useEffect(() => {
    const initialColumns = getUtilityGridColumns(t, isExpanded, isModEdit, utilityEditRequests, classes);
    setColumns(initialColumns);
  }, [t, isExpanded, isModEdit, utilityEditRequests]);

  const handleRefreshGrid = () => {
    dispatch(
      placementModsAction.getFurnitureModDetails({
        placementId: selectedModsDetails?.placementId,
        travelerOptionId: selectedModsDetails?.travelerOptionId,
      }),
    );
  };

  const getWidth = () => {
    if (isCallingAPI || !isExpanded) {
      return '780px';
    } else {
      return null;
    }
  };

  const resetColumns = () => {
    setColumns(getUtilityGridColumns(t, isExpanded, isModEdit, utilityEditRequests, classes));
  };

  const getHeaderCount = utilityEditRequests => {
    const totalRowCount = utilityEditRequests?.length;
    setHeaderCount(totalRowCount);
  };

  const getSecondaryCount = utilityEditRequests => {
    const includedRowCount = utilityEditRequests?.filter(each => each?.include)?.length
      ? utilityEditRequests?.filter(each => each?.include)?.length
      : 0;
    setSecondaryCount(includedRowCount);
  };
  useEffect(() => {
    if (isUndoModal) {
      dispatch(placementModsAction.setFurnitureCostToTravelError([]));
      dispatch(placementModsAction.setGridModError(false));
      dispatch(placementModsAction.setIsUndoModal(false));
    }
  }, [isUndoModal]);
  useEffect(() => {
    if (utilityEditRequests?.length === 0) {
      dispatch(placementModsAction.setGridModError(true));
    } else if (furnitureCostToTravelerErrors.some(val => val.costToTravel)) {
      dispatch(placementModsAction.setGridModError(true));
    } else {
      dispatch(placementModsAction.setGridModError(false));
    }
    getHeaderCount(isModEdit ? utilityEditRequests : utilityRequests);
    getSecondaryCount(isModEdit ? utilityEditRequests : utilityRequests);
  }, [furnitureCostToTravelerErrors, utilityEditRequests]);
  const UtilityGrid = React.useMemo(() => {
    return (
      <Grid style={{ paddingBottom: '24px' }}>
        <XGrid
          gridTag={gridTags.UTILITYGRIDTAG}
          rows={isModEdit ? getFormattedUtility(utilityEditRequests) || [] : getFormattedUtility(utilityRequests) || []}
          columns={columns}
          disableSelectionOnClick
          editMode="row"
          pagination={false}
          autoHeight={true}
          sx={{ minWidth: '700px' }}
          hideFooter
          inDialog
          title={t('placement.placementMods.utility')}
          secondaryTitle={`/ ${t('placement.placementMods.included')} (${secondaryCount})`}
          displayCustomCount={selectedIds?.length > 0 ? selectedIds?.length : headerCount}
          loading={isCallingAPI}
          className={classes.expandedGrid}
          toolbarProps={{
            refreshButton: true,
            columnSelector: isModEdit ? false : true,
            resetColumns: () => {
              resetColumns(),
                dispatch(
                  globalActions.setSnackBar({
                    message: 'Columns have been reset.',
                    severity: 'success',
                  }),
                );
            },
            refreshGrid: () => {
              handleRefreshGrid();
            },
          }}
        />
      </Grid>
    );
  }, [utilityRequests, isExpanded, isCallingAPI, resetColumns, columns, utilityEditRequests]);

  return (
    <Grid item xs={12} sx={{ width: getWidth() }}>
      {UtilityGrid}
    </Grid>
  );
};
